import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';

//We we'll use the BaseUrlChangeDialogComponent openDialog this is like an interface - it will NOT be called 
export class CanComponentDeactivate {

  subject = new Subject<boolean>();

  openDialog() {

    //console.log('opn dialog');
    //this.showDialog = true;

  }

}


@Injectable({
  providedIn: 'root'
})
export class ConfirmationGuard implements CanDeactivate<CanComponentDeactivate> {

  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    //console.log('deactivate');

    let subject = new Subject<boolean>();

    //We we'll use the BaseUrlChangeDialogComponent
    if (component && component != null) {

      component.openDialog();
      subject = component.subject;

    } else { //we are not logged in so we can move page by page since we wrap our code in is logged in

      return of(true);
    }

    return subject.asObservable();
  }
}